import Header from '../../components/Header'
import React, { useEffect, useState } from "react";
import { ThreeDots } from "react-loader-spinner";
import { post } from '../../services/api';

export default function VacaLeiteira() {
    const dadosRequisicao = JSON.parse(sessionStorage.getItem('dadosRequisicaoVacaLeiteira'));

    const [carregandoDados, setCarregandoDados] = useState(false);
    const [dadosAnimal, setDadosAnimal] = useState({});

    useEffect(() => {
        getDados();
    }, []);

    useEffect(() => {
        document.body.style.backgroundColor = 'white';

        return () => {
            document.body.style.backgroundColor = '';
        };
    }, []);

    async function getDados() {
        try {
            const [mes, ano] = dadosRequisicao.mesAno.split('-');

            const requisicao = {
                vendedor: dadosRequisicao.idVendedor,
                mes: mes,
                ano: ano,
            };

            setCarregandoDados(true);

            const response = await post('vacaleiteira/getanimal', requisicao);

            setCarregandoDados(false);

            if (response.status === 'OK') {
                setDadosAnimal(response);
            }
        } catch (error) {
            if (error.response) {
                console.error('Erro na resposta do servidor:', error.response.data);
            } else if (error.request) {
                console.error('Sem resposta do servidor:', error.request);
            } else {
                console.error('Erro durante a configuração da requisição:', error.message);
            }
        }
    }

    function formatoMoeda(value) {
        return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value);
    }

    function mesAtual() {
        const meses = [
            'Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho',
            'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'
        ];

        const [mes, ano] = dadosRequisicao.mesAno.split('-');
        const mesAtual = mes - 1;
        const anoAtual = ano;

        return `${meses[mesAtual]} de ${anoAtual}`;
    }

    if (carregandoDados) {
        return (
            <>
                <Header type="otherPage" />
                <div className='flex justify-center items-center'>
                    <span className='text-xl'>Carregando Dados</span>
                    <ThreeDots
                        height="8"
                        width="60"
                        radius="15"
                        color="#000000"
                        ariaLabel="three-dots-loading"
                        wrapperStyle={{}}
                        wrapperClassName=""
                        visible={true}
                    />
                </div>
            </>
        )
    }

    if (!Object.keys(dadosAnimal).length || dadosAnimal.dados.length === 0) {
        return (
            <>
                <Header type="otherPage" />
                <div className='flex justify-center items-center'>
                    <span className='text-xl'>Sem dados no momento</span>
                </div>
            </>
        )
    }

    return (
        <div>
            <Header type="otherPage" />
            <section className="pt-12">
                <div className="container">
                    <div className="font-poppins text-gray-c5 text-center">
                        <h2 className="font-semibold text-[26px]">Acompanhe uma visão detalhada do seu progresso em Vaca Leiteira</h2>
                        <p className="font-normal text-lg pt-1">Mês atual ({mesAtual()})</p>
                        <div className="overflow-x-auto my-6">
                            <table className="table-progresso">
                                <thead>
                                    <tr>
                                        <th>Departamento</th>
                                        <th>Ano Ant</th>
                                        <th>Ano Atual</th>
                                        <th>Comp. Unid %</th>
                                        <th>Ano Ant</th>
                                        <th>Ano Atual</th>
                                        <th>Comp. R$ %</th>
                                        <th>Part.</th>
                                        <th>Realizado Margem Verbas</th>
                                        <th>Realizado Juros Totais</th>
                                        <th>Total Realizado Margem Juros</th>
                                        <th>Vaca Leiteira</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {dadosAnimal.dados.map((item, index) => (
                                        <tr key={index}>
                                            <td>{item.agrupador}</td>
                                            <td>{item.quantidadepassado}</td>
                                            <td>{item.quantidade}</td>
                                            <td>{item.quantidadecomparativo.replace('.', ',')}</td>
                                            <td>{formatoMoeda(item.totalpresentepassado)}</td>
                                            <td>{formatoMoeda(item.totalpresente)}</td>
                                            <td>{item.totalpresentecomparativo.replace('.', ',')}</td>
                                            <td>{item.margemverbasjurosporc.replace('.', ',')}</td>
                                            <td>{formatoMoeda(item.margemverbas)}</td>
                                            <td>{formatoMoeda(item.jurostotais)}</td>
                                            <td>{formatoMoeda(item.margemverbasjuros)}</td>
                                            <td>{item.vacaleiteira.replace('.', ',')}</td>
                                        </tr>
                                    ))}
                                </tbody>
                                <tfoot>
                                    <tr>
                                        <td>Total</td>
                                        <td>{dadosAnimal.dados[0].somaquantidadepassado}</td>
                                        <td>{dadosAnimal.dados[0].somaquantidade}</td>
                                        <td>{dadosAnimal.dados[0].somaquantidadecomparativo.replace('.', ',')}</td>
                                        <td>{formatoMoeda(dadosAnimal.dados[0].somatotalpresentepassado)}</td>
                                        <td>{formatoMoeda(dadosAnimal.dados[0].somatotalpresente)}</td>
                                        <td>{dadosAnimal.dados[0].somatotalpresentecomparativo.replace('.', ',')}</td>
                                        <td>{dadosAnimal.dados[0].somamargemverbasjurosporc}</td>
                                        <td>{formatoMoeda(dadosAnimal.dados[0].somamargemverbas)}</td>
                                        <td>{formatoMoeda(dadosAnimal.dados[0].somajurostotais)}</td>
                                        <td>{formatoMoeda(dadosAnimal.dados[0].somamargemverbasjuros)}</td>
                                        <td>{dadosAnimal.dados[0].somavacaleiteira.replace('.', ',')}</td>
                                    </tr>
                                </tfoot>
                            </table>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );

}
